/**
 * inDrive's marks, from indrive.com/images/logo.
 *
 * Inlined as components rather than <img src="/brand/logo-icon.svg"> so the
 * wordmark can take its colour from the surrounding text — one file that works
 * in both light and dark, instead of two that have to be swapped by hand.
 */

export const INDRIVE_LIME = '#C1F11D';
export const INDRIVE_INK = '#141414';

export function IndriveIcon({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M0 20C0 14.4513 0 11.6563 0.766046 9.44099C2.17391 5.38302 5.34162 2.19462 9.39959 0.766046C11.6356 0 14.3892 0 19.9172 0C25.4451 0 28.2195 0 30.4348 0.766046C34.4721 2.17391 37.6605 5.36232 39.0683 9.44099C39.8344 11.677 39.8344 14.4513 39.8344 20C39.8344 25.5487 39.8344 28.3437 39.0683 30.559C37.6605 34.617 34.4928 37.8054 30.4348 39.234C28.1988 40 25.4451 40 19.9172 40C14.3892 40 11.6149 40 9.39959 39.234C5.36232 37.8261 2.17391 34.6377 0.766046 30.559C0 28.3437 0 25.5694 0 20Z"
        fill={INDRIVE_LIME}
      />
      <path d="M15.8863 15.9141H11.0312V30.1811H15.8863V15.9141Z" fill={INDRIVE_INK} />
      <path
        d="M21.9453 9.09961H18.1172V13.8636H21.8315C25.2269 13.8636 27.5747 16.2797 27.5747 19.6069C27.5747 22.934 25.2269 25.4185 21.8315 25.4185H18.1172V30.1824H21.9453C27.9619 30.1824 32.4961 25.5779 32.4961 19.5862C32.4961 13.5944 27.9619 9.10375 21.9453 9.10375V9.09961Z"
        fill={INDRIVE_INK}
      />
      <path d="M15.8863 9.09961H11.0312V13.8636H15.8863V9.09961Z" fill={INDRIVE_INK} />
    </svg>
  );
}

export function IndriveWordmark({ height = 18 }: { height?: number }) {
  return (
    <svg
      width={Math.round((99 / 24) * height)}
      height={height}
      viewBox="0 0 99 24"
      fill="none"
      role="img"
      aria-label="inDrive"
    >
      <path d="M77.7185 7.3623L73.8668 18.9174L70.0794 7.3623H65.2207L71.0366 23.3264H76.5106L82.3948 7.3623H77.7185Z" fill="currentColor" />
      <path d="M50.6919 10.8887V7.3623H46.4258V23.3264H50.9881V16.5989C50.9881 12.9275 53.2673 11.6947 56.0498 11.6947H57.4422V7.3623H56.4829C53.837 7.3623 51.5206 8.3734 50.6919 10.8887Z" fill="currentColor" />
      <path d="M63.5407 7.3623H58.9785V23.3264H63.5407V7.3623Z" fill="currentColor" />
      <path d="M63.5407 0.664062H58.9785V5.42801H63.5407V0.664062Z" fill="currentColor" />
      <path d="M4.5622 7.3623H0V23.3264H4.5622V7.3623Z" fill="currentColor" />
      <path d="M4.5622 0.664062H0V5.42801H4.5622V0.664062Z" fill="currentColor" />
      <path d="M17.0654 6.94434C14.8709 6.94434 13.1289 7.85284 12.1484 9.35942V7.36247H7.58618V23.3266H12.1484V14.6017C12.1484 12.4913 13.4137 11.1315 15.3323 11.1315C17.2509 11.1315 18.3691 12.3399 18.3691 14.3195V23.3266H22.9313V13.4535C22.9313 9.53588 20.5624 6.94434 17.0654 6.94434Z" fill="currentColor" />
      <path d="M33.0703 0.664062H29.2422V5.42801H32.9565C36.3519 5.42801 38.6997 7.84403 38.6997 11.1712C38.6997 14.4983 36.3519 16.9828 32.9565 16.9828H29.2422V21.7467H33.0703C39.0869 21.7467 43.6211 17.1422 43.6211 11.1505C43.6211 5.1587 39.0869 0.668003 33.0703 0.668003V0.664062Z" fill="currentColor" />
      <path d="M27.0113 7.36328H22.4492V21.7469H27.0113V7.36328Z" fill="currentColor" />
      <path d="M27.0113 0.664062H22.4492V5.42801H27.0113V0.664062Z" fill="currentColor" />
      <path d="M91.0446 6.94434C86.3683 6.94434 82.8418 10.4634 82.8418 15.3444C82.8418 20.2255 86.3683 23.7446 91.2519 23.7446C95.0733 23.7446 97.9299 21.6342 98.7586 18.3071H94.1964C93.7302 19.4114 92.6119 20.0157 91.2519 20.0157C89.2296 20.0157 87.8697 18.7727 87.4726 16.8944H98.9659C99.0696 16.3833 99.0696 15.8722 99.0696 15.3611C99.0696 10.4634 95.6467 6.94434 91.0446 6.94434ZM87.5417 13.5535C88.0079 11.8121 89.2296 10.6733 91.0446 10.6733C92.8595 10.6733 94.1158 11.7776 94.5129 13.5535H87.5417Z" fill="currentColor" />
    </svg>
  );
}
